export default __webpack_public_path__ + "static/Quickinstallation_Lense-Adjust_5905_04-3379073410e31bdd5a42fff758c83f8f.webp";